import { CountryCode } from './geo.types';
import { countries, provinces } from './geo.const';

export const getProvinces = (country: CountryCode) => {
  return provinces.filter((province) => {
    return province.country === country;
  });
};

export const getCountries = () => {
  return countries;
};


// WEBPACK FOOTER //
// ./src/geo/geo.tsx